import { z } from 'zod';
import { CoreObjectTypeSchema } from '../inputTypeSchemas/CoreObjectTypeSchema'
import { CoreCustomFieldTypeSchema } from '../inputTypeSchemas/CoreCustomFieldTypeSchema'

/////////////////////////////////////////
// CORE CUSTOM FIELD SCHEMA
/////////////////////////////////////////

export const CoreCustomFieldSchema = z.object({
  resourceType: CoreObjectTypeSchema,
  type: CoreCustomFieldTypeSchema,
  lookUpType: CoreObjectTypeSchema.nullable(),
  id: z.number().int(),
  cityId: z.number().int(),
  resourceId: z.number().int(),
  label: z.string(),
  name: z.string(),
  description: z.string(),
  required: z.boolean(),
  standardField: z.boolean(),
  decimalPlaces: z.number().int().nullable(),
  unit: z.string().nullable(),
  picklistId: z.number().int().nullable(),
  deactivatedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
})

export type CoreCustomField = z.infer<typeof CoreCustomFieldSchema>

export default CoreCustomFieldSchema;
